import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	switchToCompassCta: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-compass-cta',
		defaultMessage: 'Switch to Compass components',
		description: 'Header CTA for users to switch to Compass components.',
	},
	compassDescription: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-description',
		defaultMessage:
			'Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more</link>',
		description: 'Description for menu item for users to switch to Compass components.',
	},
	compassAdminActionHint: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-admin-action-hint',
		defaultMessage:
			'If you switch, you’ll still see read-only Jira components. You can switch back at any time.',
		description:
			'Hint for users on what toggling Compass components will do. Shown only to admins.',
	},
	compassActionHint: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-action-hint',
		defaultMessage: 'If your admin switches, you’ll still see read-only Jira components.',
		description: 'Hint for users on what toggling Compass components will do. Shown to non-admins.',
	},
	switchToJiraCta: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-jira-cta',
		defaultMessage: 'Switch to Jira components',
		description: 'Header CTA for users to switch to Jira components.',
	},
	jiraDescription: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-description',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more</link>',
		description: 'Description for menu item for users to switch to Jira components.',
	},
	jiraAdminActionHint: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-admin-action-hint',
		defaultMessage:
			'If you switch, you’ll still see read-only Compass components. You can switch back at any time.',
		description:
			'Hint for users on what toggling Compass components will do. Shown only to admins.',
	},
	jiraActionHint: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-action-hint',
		defaultMessage: 'If your admin switches, you’ll still see read-only Compass components.',
		description: 'Hint for users on what toggling Compass components will do. Shown to non-admins.',
	},
	newLozenge: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.new-lozenge',
		defaultMessage: 'New',
		description: 'Lozenge message to let users know this is a new feature.',
	},
	giveFeedback: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.give-feedback',
		defaultMessage: 'Give feedback',
		description: 'Menu item for users to give feedback.',
	},
	askAdmin: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.ask-admin',
		defaultMessage: 'Ask your admin to switch to Compass components.',
		description: 'Prompt for non-admins to request Compass components from an admin.',
	},
	feedbackTitle: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.title',
		defaultMessage: 'Give feedback',
		description: 'Title for Global Components feedback collector.',
	},
	feedbackPlaceholder: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.placeholder',
		defaultMessage: 'Write feedback',
		description: 'Placeholder text for Global Components feedback collector.',
	},
	submitButtonLabel: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.submit-button',
		defaultMessage: 'Submit',
		description: 'Submit button label for Global Components feedback collector.',
	},
	skipButtonLabel: {
		id: 'project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.skip-button',
		defaultMessage: 'Skip',
		description: 'Skip button label for Global Components feedback collector.',
	},
});
